var wrapper = $('.Product__Gallery');
var video = wrapper.find('.product-video__media');
// Taking all the product-video__media
video.each(function(i, e) {
    // remove the img in native video to prevent query from the photoswipe function to access the wrong img element
    $(e).find('img').remove();
    // hide the img if the media is video so the video in the background can show
    if($('.Product__Slideshow').find($(e)).length == 1) {
        $(e).next().addClass('no-show')
    }
})
